import { OrderingInitialState, SetNoteAction } from '@reducers/ordering/types';

export const setNote = (state: OrderingInitialState, action: SetNoteAction): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    note: action.payload,
  },
});
